import {
    FETCH_MAIN_AGREEMENT_LIST_REQUEST,
    FETCH_MAIN_AGREEMENT_LIST_SUCCESS,
    FETCH_MAIN_AGREEMENT_LIST_FAILURE,

    CREATE_MAIN_AGREEMENT_REQUEST,
    CREATE_MAIN_AGREEMENT_SUCCESS,
    CREATE_MAIN_AGREEMENT_FAILURE,

    UPDATE_MAIN_AGREEMENT_REQUEST,
    UPDATE_MAIN_AGREEMENT_SUCCESS,
    UPDATE_MAIN_AGREEMENT_FAILURE
} from './types';


/**
 *
 * @param {Object} [params]
 * @returns
 */
 export const fetchMainAgreementListRequest = (params) => ({
    type: FETCH_MAIN_AGREEMENT_LIST_REQUEST,
    payload: params
});

/**
 *
 * @param {MainAgreementListState} data
 * @returns
 */
export const fetchMainAgreementListSuccess = (data) => ({
    type: FETCH_MAIN_AGREEMENT_LIST_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function fetchMainAgreementListFailure(error) {
    return {
        type: FETCH_MAIN_AGREEMENT_LIST_FAILURE,
        error
    };
}




/**
 *
 * @param {Object} [params]
 * @returns
 */
 export const createMainAgreementRequest = (params) => ({
    type: CREATE_MAIN_AGREEMENT_REQUEST,
    payload: params
});

export const createMainAgreementSuccess = (data) => ({
    type: CREATE_MAIN_AGREEMENT_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function createMainAgreementFailure(error) {
    return {
        type: CREATE_MAIN_AGREEMENT_FAILURE,
        error
    };
}



/**
 *
 * @param {MainAgreement} params
 * @returns
 */
 export const updateMainAgreementRequest = (params) => ({
    type: UPDATE_MAIN_AGREEMENT_REQUEST,
    payload: params
});

export const updateMainAgreementSuccess = (data) => ({
    type: UPDATE_MAIN_AGREEMENT_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function updateMainAgreementFailure(error) {
    return {
        type: UPDATE_MAIN_AGREEMENT_FAILURE,
        error
    };
}
